export function getApiBase(): string {
  if (typeof window === 'undefined') return 'http://127.0.0.1:8000'
  const { hostname, origin } = window.location
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:8000'
  }
  return origin
}
